module.exports = __webpack_public_path__ + "static/media/hp_ex_human.bd256076.jpg";